module.exports = __webpack_public_path__ + "825aeaf727faf1b5df8dd23e544a2579.jpg";